module.exports = __webpack_public_path__ + "static/add-program-84ee15ab83ee193741ead65025e416c9.png";